import { Controller } from 'stimulus'
import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel'

export default class extends Controller {
  declare dotsContainerTarget: HTMLElement
  static targets = ['dotsContainer']

  connect() {
    this.initializeCarousel()
  }

  initializeCarousel() {
    const emblaApi = EmblaCarousel(this.element as HTMLElement, { loop: true })

    const removeDotBtnsAndClickHandlers =
      this.addDotBtnsAndClickHandlers(emblaApi)

    emblaApi.on('destroy', removeDotBtnsAndClickHandlers)
  }

  addDotBtnsAndClickHandlers(emblaApi: EmblaCarouselType) {
    let dotNodes: HTMLElement[] = []

    const addDotBtnsWithClickHandlers = () => {
      this.dotsContainerTarget.innerHTML = emblaApi
        .scrollSnapList()
        .map(() => '<button class="embla__dot" type="button"></button>')
        .join('')

      dotNodes = Array.from(
        this.dotsContainerTarget.querySelectorAll<HTMLElement>('.embla__dot'),
      )
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener('click', () => emblaApi.scrollTo(index), false)
      })
    }

    const toggleDotBtnsActive = () => {
      const previous = emblaApi.previousScrollSnap()
      const selected = emblaApi.selectedScrollSnap()
      dotNodes[previous]?.classList.remove('embla__dot--selected')
      dotNodes[selected]?.classList.add('embla__dot--selected')
    }

    emblaApi
      .on('init', addDotBtnsWithClickHandlers)
      .on('reInit', addDotBtnsWithClickHandlers)
      .on('init', toggleDotBtnsActive)
      .on('reInit', toggleDotBtnsActive)
      .on('select', toggleDotBtnsActive)

    return () => {
      this.dotsContainerTarget.innerHTML = ''
    }
  }
}
